// Reception Today board: red reminder until the day's opening cash float (INITIAL deposit) is registered with EFI.
import React, { useEffect, useState } from 'react';
import { Banknote, Loader2, AlertOctagon, ArrowRight } from 'lucide-react';
import { apiCall } from './_shared';

const CashFloatBanner = ({ onNavigate }) => {
  const [data, setData] = useState(null);
  const [amount, setAmount] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const load = () => apiCall('/api/admin/fiscal/cash-deposit?days=1').then(setData).catch(() => {});
  useEffect(() => { load(); const id = setInterval(load, 5 * 60 * 1000); return () => clearInterval(id); }, []);

  if (!data || data.today_initial) return null;

  const register = async () => {
    const a = Number(amount);
    if (!(a > 0)) { setErr('Enter the opening float amount'); return; }
    if (!window.confirm(`Register opening cash float of €${a.toFixed(2)} with the Tax Administration?`)) return;
    setBusy(true); setErr('');
    try { await apiCall('/api/admin/fiscal/cash-deposit', { method: 'POST', body: JSON.stringify({ amount: a, operation: 'initial' }) }); await load(); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border border-red-300 bg-red-600 text-white p-3 flex flex-wrap items-center gap-3 shadow-sm" data-testid="cash-float-banner">
      <AlertOctagon className="w-5 h-5 flex-shrink-0" />
      <div className="flex-1 min-w-[220px]">
        <div className="font-bold text-sm">Opening cash float not registered for {data.today}</div>
        <div className="text-xs text-red-100">Register the initial cash deposit (početno stanje) with the Tax Administration before issuing the first cash invoice.{!data.ready && ' Fiscalization is not configured yet — ask an admin to complete Finance → Settings.'}</div>
      </div>
      {data.ready && (
        <div className="flex items-center gap-1">
          <input type="number" min="0" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Float €" className="w-28 rounded-lg px-2 py-1.5 text-sm text-slate-900" data-testid="cash-float-amount" />
          <button type="button" onClick={register} disabled={busy} className="inline-flex items-center gap-1 bg-white text-red-700 rounded-lg px-3 py-1.5 text-sm font-bold disabled:opacity-60" data-testid="cash-float-register">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Banknote className="w-4 h-4" />} Register
          </button>
        </div>
      )}
      {onNavigate && (
        <button type="button" onClick={() => onNavigate({ tab: 'finance', finance_tab: 'fiscal' })} className="inline-flex items-center gap-1 text-xs font-semibold underline" data-testid="cash-float-open-fiscal">
          Fiscal Day <ArrowRight className="w-3 h-3" />
        </button>
      )}
      {err && <div className="w-full text-xs bg-red-700 rounded px-2 py-1" data-testid="cash-float-error">{err}</div>}
    </div>
  );
};

export default CashFloatBanner;
